import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { IMAGE_CAPTURE_STEPS } from '../../../constants';

export default function useCaptureSteps() {
    const navigate = useNavigate()

    const [activeStep, setActiveStep] = useState(IMAGE_CAPTURE_STEPS.GLOBAL_CROWN);

    const handleLoadNextStep = useCallback(() => {
        setActiveStep((prevActiveStep) => {
            switch (prevActiveStep) {
                case IMAGE_CAPTURE_STEPS.GLOBAL_CROWN:
                    return IMAGE_CAPTURE_STEPS.GLOBAL_RIGHT;
                case IMAGE_CAPTURE_STEPS.GLOBAL_RIGHT:
                    return IMAGE_CAPTURE_STEPS.GLOBAL_LEFT;
                case IMAGE_CAPTURE_STEPS.GLOBAL_LEFT:
                    return IMAGE_CAPTURE_STEPS.IMAGE_UPLOAD;
                default:
                    return IMAGE_CAPTURE_STEPS.GLOBAL_CROWN;
            }
        })
    }, []);

    const handleLoadPreviousStep = useCallback(() => {
        setActiveStep((prevActiveStep) => {
            switch (prevActiveStep) {
                case IMAGE_CAPTURE_STEPS.GLOBAL_CROWN:
                    navigate(-1)
                    return IMAGE_CAPTURE_STEPS.GLOBAL_CROWN;
                case IMAGE_CAPTURE_STEPS.GLOBAL_RIGHT:
                    return IMAGE_CAPTURE_STEPS.GLOBAL_CROWN;
                case IMAGE_CAPTURE_STEPS.GLOBAL_LEFT:
                    return IMAGE_CAPTURE_STEPS.GLOBAL_RIGHT;
                case IMAGE_CAPTURE_STEPS.IMAGE_UPLOAD:
                    return IMAGE_CAPTURE_STEPS.GLOBAL_LEFT;
                default:
                    return IMAGE_CAPTURE_STEPS.GLOBAL_CROWN;
            }
        })
    }, [navigate])

    const handleLoadGlobalCapture = useCallback(() => {
        setActiveStep(IMAGE_CAPTURE_STEPS.GLOBAL_CROWN);
    }, [])

    return {
        activeStep,
        handleLoadNextStep,
        handleLoadPreviousStep,
        handleLoadGlobalCapture
    }
}
